export const CourseTypeEnum = {
    National: 1,
    District: 2,
}

export const CourseTypeEnumText = {
    National: "National",
    District: "District",
}